import { Currency } from "../contexts/CurrencyContext";
import { PricingTiers } from "./pricing-data";

export const getCurrencySymbol = (currency: Currency): string => {
    switch (currency) {
        case 'GBP': return '£';
        case 'USD': return '$';
        case 'EUR': return '€';
        case 'AUD': return '$';
        case 'INR': return '₹';
        default: return '£';
    }
}

export const formatPrice = (value: number, currency: Currency): string => {
    const symbol = getCurrencySymbol(currency);
    // INR typically doesn't use decimals for larger amounts, but we'll stick to standard formatting
    // If it's an integer, don't show decimals, otherwise show 2.
    // Actually, design usually prefers .00 for alignment if others have it, but let's see. 
    // The previous implementation had mixed (e.g. £4.99 vs £25.00 vs ₹199).

    // For INR, we usually format without decimals if whole number.
    if (currency === 'INR') {
        return `${symbol}${value.toLocaleString('en-IN')}`;
    }

    return `${symbol}${value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export const roundPrice = (value: number): number => {
    const integerPart = Math.floor(value);
    const decimalPart = value - integerPart;

    // Logic: 
    // < 0.25 -> .00
    // 0.25 - 0.75 -> .50
    // > 0.75 -> .99 (Marketing friendly)

    if (decimalPart < 0.25) return integerPart;
    if (decimalPart < 0.75) return integerPart + 0.50;
    return integerPart + 0.99;
}

export const calculateSavings = (base: number, discounted: number): string => {
    if (base === 0) return '0%';
    const savings = ((base - discounted) / base) * 100;
    return `${Math.round(savings)}%`;
}

// Helper to get raw price for calculation if needed, though direct access is preferred
export const getPriceValue = (_currency: Currency, _tier: keyof typeof PricingTiers, _period: 'monthly' | 'annual'): number => {
    // This might be circular if PricingTiers uses utils?
    // Actually PricingTiers is data. Utils imports data.
    // But we want to use this in components.
    return 0; // Placeholder if complex logic needed.
}
